import { formatNumber } from "@/utils";
export default [
  {
    prop: "Rnc",
    label: "RNC",
    "min-width": 130,
    fixed: true,
    "header-align": "center",
    align: "center",
    sortable: true
  },
  {
    prop: "Nombre",
    label: "Empresa",
    "min-width": 300,
    fixed: true,
    "header-align": "center",
    sortable: true
  },
  {
    prop: "January",
    label: "26 Diciembre - 25 Enero",
    "min-width": 220,
    align: "center",
    "header-align": "center",
    sortable: true,
    formatter: ({ January }) => formatNumber(January)
  },
  {
    prop: "February",
    label: "26 Enero - 25 Febrero",
    "min-width": 220,
    align: "center",
    "header-align": "center",
    sortable: true,
    formatter: ({ February }) => formatNumber(February)
  },
  {
    prop: "March",
    label: "26 Febrero - 25 Marzo",
    "min-width": 220,
    align: "center",
    "header-align": "center",
    sortable: true,
    formatter: ({ March }) => formatNumber(March)
  },
  {
    prop: "April",
    label: "26 Marzo - 25 Abril",
    "min-width": 220,
    align: "center",
    "header-align": "center",
    sortable: true,
    formatter: ({ April }) => formatNumber(April)
  },
  {
    prop: "May",
    label: "26 Abril - 25 Mayo",
    "min-width": 220,
    align: "center",
    "header-align": "center",
    sortable: true,
    formatter: ({ May }) => formatNumber(May)
  },
  {
    prop: "June",
    label: "26 Mayo - 25 Junio",
    "min-width": 220,
    align: "center",
    "header-align": "center",
    sortable: true,
    formatter: ({ June }) => formatNumber(June)
  },
  {
    prop: "July",
    label: "26 Junio - 25 Julio",
    "min-width": 220,
    align: "center",
    "header-align": "center",
    sortable: true,
    formatter: ({ July }) => formatNumber(July)
  },
  {
    prop: "August",
    label: "26 Julio - 25 Agosto",
    "min-width": 220,
    align: "center",
    "header-align": "center",
    sortable: true,
    formatter: ({ August }) => formatNumber(August)
  },
  {
    prop: "September",
    label: "26 Agosto - 25 Septiembre",
    "min-width": 220,
    align: "center",
    "header-align": "center",
    sortable: true,
    formatter: ({ September }) => formatNumber(September)
  },
  {
    prop: "October",
    label: "26 Septiembre - 25 Octubre",
    "min-width": 230,
    align: "center",
    "header-align": "center",
    sortable: true,
    formatter: ({ October }) => formatNumber(October)
  },
  {
    prop: "November",
    label: "26 Obtubre - 25 Noviembre",
    "min-width": 230,
    align: "center",
    "header-align": "center",
    sortable: true,
    formatter: ({ November }) => formatNumber(November)
  },
  {
    prop: "December",
    label: "26 Noviembre - 25 Diciembre",
    "min-width": 240,
    align: "center",
    "header-align": "center",
    sortable: true,
    formatter: ({ December }) => formatNumber(December)
  }
];
